/**
 * Where the customer's project pages live. Each names its project, so a
 * customer with two of them is reading one of them and not whichever the
 * server would have picked.
 *
 * `PROJECT_ROUTE` is the entry with no project named yet: it resolves one and
 * sends the reader on, which is what a link out of a mail or a bookmark from
 * before this hits.
 */
export const PROJECT_ROUTE = '/customer/project'
export const projectRoute = (projectId: number): string =>
  `${PROJECT_ROUTE}/${projectId}`
export const configuratorRoute = (projectId: number): string =>
  `${projectRoute(projectId)}/configure`
/** Summary of everything the customer configured — the last step of the
 *  configurator, and a destination they can return to. */
export const configuratorSummaryRoute = (projectId: number): string =>
  `${projectRoute(projectId)}/summary`
export const DASHBOARD_ROUTE = '/customer/dashboard'
export const MATCHES_ROUTE = '/customer/matches'
/** What every customer route starts with — the advisor's shadow view rewrites
 *  exactly this much of it. */
export const CUSTOMER_ROUTE_PREFIX = '/customer/'
export const ACCOUNT_ROUTE = '/customer/account'
export const INTERNAL_ACCOUNT_ROUTE = '/internal/account'

/** The online exposé for a project — the entry point of the public loop. */
export const publicProjectRoute = (projectId: number): string =>
  `/public/projects/${projectId}`

// Public configurator (DB-backed)
export const PUBLIC_CONFIGURATOR_ROUTE = '/public/configurator'
export const PUBLIC_CONFIGURATOR_SUMMARY_ROUTE = '/public/configurator/summary'
